export const TREATMENT_SERVICE_PREFIXES = [
  'assessment_97151',
  'assessment_97152',
  'direct_therapy_97153',
  'protocol_modification_97155',
  'parent_training_97156',
  'group_parent_training_97157',
  'care_coordination_99366',
] as const;

export const TREATMENT_SERVICE_FREQUENCIES = [
  'Weekly',
  'bi-weekly',
  'Monthly',
  '6-months authorization period',
] as const;
